
import {Component, Vue} from "vue-property-decorator";
import {ICar} from "@/modules/Car/interfaces/car.interface";
import {IAuth} from "@/modules/Auth/interfaces/auth.interface";
import {IBook} from "@/interfaces/book.interface";
import {corpRequest} from "@/modules/Corps/resources/corp.resource";
import {ICorpRequest} from "@/modules/Corps/interfaces/corp-request.interface";
import {IAppState} from "@/interfaces/app-state.interface";
import AppCorpsFilter from "@/components/FormControls/AppCorpsFilter.vue";
import {httpResource} from "@/resources/http.resource";

@Component({
  components: {AppCorpsFilter}
})
export default class CorpField extends Vue {
  corps = [];

  get storeState(): IAppState { return this.$store.state; }
  get formModel(): ICar.IEntity { return this.storeState.car.formData.formModel; }
  get startForm(): ICar.IEntity { return this.storeState.car.formData.startForm; }

  get userAccess(): IAuth.UserAccess { return this.storeState.auth.userAccess; }
  get viewMode() { return !this.userAccess.scCarMk; }
  get corpsBook(): IBook.CorpBookItem[] { return this.$store.getters['car/carInfoBookCorps']; }
  get corpOptions() { return this.corps.length ? this.corps : this.corpsBook; }

  get createCorpMode() {
    let bookItem = this.corpOptions.find(item => item.id === +this.modelValue);
    return !Boolean(bookItem);
  }

  get modelValue() { return this.formModel.corpId; }
  set modelValue(value) {
    this.setFormModelProp('corpId', value);
  };

  created() {
    this.presetBookItem();
  }

  setFormModelProp(name: string, value) {
    this.$store.commit('car/setFormProperty', {formName: 'formModel', name, value });
  }

  presetBookItem() {
    let bookValue = this.corpsBook.find(item => item.id === +this.modelValue);
    if (!Boolean(bookValue)) {
      this.$store.commit('book/addItemInBook', {
        bookName: IBook.BookName.Corps,
        item: {
          id: +this.modelValue,
          name: this.formModel.corpName,
        },
      });
    }
  }

  async getCorps(corp) {
    let asyncAction = async () => {
      const params = { tableName: IBook.TableName.Corps, searchText: corp } ;
      const {data: {result: {corps: responseCorps } }} = await httpResource.httpAction({ action: IBook.ACTION, params });
      this.corps = responseCorps;
    };
    await this.$store.dispatch('defaultResourceAction', { asyncAction });
  }

  inputCorps(value) {
    let corpName = '';
    if (typeof value === 'number') {
      this.modelValue = value;
    }
    if (typeof value === 'string') {
      corpName = value;
    }
    this.setFormModelProp('corpName', corpName);
    this.$emit('formItemChange');
  }

  changeCorp() {
    let corpBook = this.corpOptions.find(item => item.id === this.formModel.corpId);
    if (corpBook) {
      this.setFormModelProp('parks', corpBook.dftParkId ? [corpBook.dftParkId] : []);
    }
    this.$emit('formItemChange');
  }

  corpBlur(event) {
    if (!event.target.value) return;

    let enteredValue = event.target.value.toString();
    let bookItem = this.corpOptions.find(item => item.name === enteredValue);
    if (!bookItem) {
      this.setFormModelProp('corpId', enteredValue);
      this.setFormModelProp('corpName', enteredValue);
      this.$emit('formItemChange');
    }
  }

  corpClear() {
    this.setFormModelProp('corpId', null);
    this.setFormModelProp('corpName', '');
    this.setFormModelProp('parks', []);
  }

  async openOrCreateCorp() {
    if (this.createCorpMode) {
      await this.$store.dispatch('confirm/open', {
        title: 'Подтверждение',
        text: 'Создать новую корпорацию?',
        cancel: { text: 'Нет', },
        confirm: {
          text: 'Да',
          action: async () => {
            let corpId = await this.createCorp();
            await this.openCorpPopup(corpId);
          }
        },
      }, { root: true, });
    }
    else {
      await this.openCorpPopup();
    }
  }

  async createCorp() {
    let corpId = this.formModel.corpId;
    this.$emit('requestLoading', true);
    const payload: ICorpRequest.IPayloadCreateCorp = {
      name: this.formModel.corpName,
      phone: this.formModel.phone,
      email: this.formModel.email,
    };
    const requestData = await corpRequest.createCorp(payload);
    this.$emit('requestLoading', false);
    if (requestData.success) {
      corpId = requestData.response;
      this.setFormModelProp('corpId', +corpId);
      this.$store.commit('book/addItemInBook', {
        bookName: IBook.BookName.Corps,
        item: {
          id: +corpId,
          name: this.formModel.corpName,
        },
      });
      return +corpId;
    }
    else {
      return null;
    }
  }

  async openCorpPopup(newCorpId = null) {
    this.$store.commit('car/setProperty', { name: 'displayContent', value: false });
    await this.$store.dispatch('dialog/openDialog', {
      blockName: 'allPages',
      dialogName: 'corpPopup',
      payload: {
        corpId: newCorpId ? newCorpId : this.formModel.corpId,
      },
    });
  }
}
